import '../../../../../vendor/assets/javascripts/waypoints.min';

const newsletterSamples = '[data-newsletter-sample]';
const newsletterForm = '.newsletter-signup-form';

function init() {
  setWaypoint();
}

function setWaypoint() {
  $(newsletterForm).waypoint(runAnimation, { offset: '90%' });
}

function runAnimation() {
  $(newsletterSamples).each(function () {
    const newsletterNum = $(this).data('newsletter-sample');
    $(this).addClass(`newsletter-sample-${newsletterNum}`);
  });
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/newsletter_samples.js